<template>
  <Popover v-slot="{ open }" class="relative">
    <PopoverButton
      :class="open ? '' : ''"
      class="flex h-12 w-12 items-center justify-center rounded-full border-2 border-white bg-theme-red text-base font-medium text-white shadow-2xl ring-1 ring-gray-500 focus:outline-none"
    >
      <font-awesome-icon :icon="['fal', 'sliders-h']" />
    </PopoverButton>
    <PopoverOverlay
      class="z-100 bg-black"
      :class="open ? 'fixed inset-0 opacity-10' : 'opacity-0'"
    />
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <PopoverPanel
        class="absolute right-0 bottom-14 z-100 mt-3 w-screen max-w-sm transform px-4 sm:px-0 lg:max-w-3xl"
      >
        <div class="overflow-hidden rounded-lg shadow-2xl ring-1 ring-black/5">
          <div class="relative space-y-5 bg-white p-5">
            <filter-planning-event-type
              v-model:event-type="dEventType"
              :eventTypeList="eventTypeList"
            />
            <filter-planning-assets
              v-model:assets="dAssets"
              :assetList="assetList"
            />
          </div>
        </div>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script>
import {
  Popover,
  PopoverButton,
  PopoverOverlay,
  PopoverPanel
} from '@headlessui/vue'
import FilterPlanningEventType from './FilterPlanningEventType'
import FilterPlanningAssets from './FilterPlanningAssets'

export default {
  name: 'FilterPlanning',
  props: {
    eventType: Array,
    assets: Array,
    assetList: Array,
    eventTypeList: Array
  },
  data() {
    return {
      dEventType: this.eventType,
      dAssets: this.assets
    }
  },
  emits: ['update:eventType', 'update:assets'],
  components: {
    FilterPlanningAssets,
    FilterPlanningEventType,
    Popover,
    PopoverOverlay,
    PopoverButton,
    PopoverPanel
  },
  created() {
    let planningFilterEventType = localStorage.getItem(
      'planning-filter-event-type'
    )
    if (planningFilterEventType && planningFilterEventType !== 'undefined') {
      this.dEventType = JSON.parse(planningFilterEventType)
      this.$emit('update:eventType', this.dEventType)
    }
    let planningFilterAssets = localStorage.getItem('planning-filter-assets')
    if (planningFilterAssets && planningFilterAssets !== 'undefined') {
      this.dAssets = JSON.parse(planningFilterAssets)
      this.$emit('update:assets', this.dAssets)
    }
  },
  watch: {
    eventType(newValue) {
      this.$emit('update:eventType', newValue)
    },
    assets(newValue) {
      this.$emit('update:assets', newValue)
    }
  }
}
</script>
